import { useEffect, useState } from "react";
import { API, getToken } from "@/lib/api";
import { Car } from "@phosphor-icons/react";

// Loads a protected file via query-param auth (img cannot send headers)
export function fileUrl(storagePath) {
  return `${API}/files/${storagePath}?auth=${getToken()}`;
}

// Resolve either an external http(s) URL or an internal storage path to a usable src
export function mediaUrl(v) {
  if (!v) return null;
  if (v.startsWith("http://") || v.startsWith("https://") || v.startsWith("data:")) return v;
  return fileUrl(v);
}

export default function AssetImage({ path, alt, className, fallbackClassName }) {
  const [ok, setOk] = useState(true);
  useEffect(() => setOk(true), [path]);
  if (!path || !ok)
    return (
      <div className={`flex items-center justify-center bg-zinc-100 text-zinc-300 ${fallbackClassName || className}`}>
        <Car size={28} weight="duotone" />
      </div>
    );
  return <img src={fileUrl(path)} alt={alt || ""} className={className} onError={() => setOk(false)} />;
}
